var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container has-background-white-ter"},[_c('input',{staticClass:"input",attrs:{"placeholder":"Tap on the virtual keyboard to start"},domProps:{"value":_vm.input}}),_c('div',{staticClass:"simple-keyboard"})])
}
var staticRenderFns = []

export { render, staticRenderFns }